
import { defineComponent } from 'vue';
import ADivider from 'ant-design-vue/es/divider';

export default defineComponent({
  components: {
    ADivider,
  },
});
